import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useCodeSandboxLink } from "../hooks/useCodeSandboxLink";
import { useSandpackTheme } from "../hooks/useSandpackTheme";
import { CSBIcon } from "../icons";
import { isDarkColor } from "../utils/stringUtils";
export var OpenInCodeSandboxButton = function OpenInCodeSandboxButton() {
  var url = useCodeSandboxLink();

  var _useSandpackTheme = useSandpackTheme(),
      theme = _useSandpackTheme.theme;

  var c = useClasser("sp");
  var csbIconClass = isDarkColor(theme.palette.defaultBackground) ? "csb-icon-dark" : "csb-icon-light";
  return React.createElement("a", {
    className: c("button", "icon-standalone", csbIconClass),
    href: url,
    rel: "noreferrer noopener",
    target: "_blank",
    title: "Open in CodeSandbox"
  }, React.createElement(CSBIcon, null));
};